import { Link } from "react-router-dom";
import { toast } from "sonner";
import { inr } from "../lib/format";
import { useStore } from "../context/StoreContext";

export default function ProductCard({ p, index = 0 }) {
  const { addToCart } = useStore();
  const img = p.images?.[0]?.url;
  const img2 = p.images?.[1]?.url || img;
  const soldOut = !p.in_stock || p.availability === "Sold out";
  const label = p.labels?.[0];

  const quickAdd = (e) => {
    e.preventDefault();
    if (soldOut) return;
    const firstSize = (p.sizes || []).find((s) => (s.stock || 0) > 0)?.size || null;
    addToCart({
      product_id: p.id, name: p.name, slug: p.slug, image: img, size: firstSize,
      color: p.colors?.[0]?.name || null, qty: 1, price: p.effective_price, mrp: p.mrp,
    });
    toast.success("Added to cart");
  };

  return (
    <Link to={`/product/${p.slug}`} className="group relative flex flex-col bg-zinc-900/40 border border-zinc-800/80 hover:border-zinc-700 transition-colors"
      data-testid={`product-card-${p.slug}`}>
      <div className="relative aspect-[3/4] overflow-hidden bg-zinc-950 hover-zoom">
        <img src={img} alt={p.images?.[0]?.alt || p.name} loading={index < 4 ? "eager" : "lazy"}
          className="absolute inset-0 w-full h-full object-cover" />
        <img src={img2} alt="" aria-hidden
          className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        {label && (
          <span className="absolute top-3 left-3 text-[10px] font-bold px-2 py-0.5 uppercase tracking-wider text-white"
            style={{ background: "var(--ss-accent)" }}>{label.text}</span>
        )}
        {p.discount_pct > 0 && !label && (
          <span className="absolute top-3 left-3 text-[10px] font-bold px-2 py-0.5 uppercase tracking-wider text-white"
            style={{ background: "var(--ss-accent)" }}>{p.discount_pct}% OFF</span>
        )}
        {soldOut && (
          <span className="absolute top-3 right-3 text-[10px] font-bold px-2 py-0.5 uppercase tracking-wider bg-zinc-800 text-zinc-300">
            Sold Out
          </span>
        )}
        {!soldOut && (
          <button onClick={quickAdd}
            className="absolute bottom-3 left-3 right-3 py-2.5 text-xs font-bold uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity btn-accent"
            data-testid={`product-card-quick-add-${p.slug}`}>
            Quick Add
          </button>
        )}
      </div>
      <div className="p-3 sm:p-4 flex flex-col gap-1">
        <h3 className="text-sm font-semibold text-zinc-100 leading-snug line-clamp-1">{p.name}</h3>
        <div className="flex items-center gap-2 flex-wrap">
          <span className="font-bold text-white">{inr(p.effective_price)}</span>
          {p.discount_pct > 0 && <span className="text-xs text-zinc-500 line-through">{inr(p.mrp)}</span>}
          {p.discount_pct > 0 && <span className="text-[11px] font-semibold text-accent">{p.discount_pct}% OFF</span>}
        </div>
      </div>
    </Link>
  );
}
